import React from 'react';
import { Card, Badge, Accordion, Row, Col } from 'react-bootstrap';
//import './IngredientsStyles.css';

const RiskBadge = ({ risk }) => {
    let badgeColor = 'success';
    let icon = '✅';

    switch (risk.toLowerCase()) {
        case 'high':
            badgeColor = 'danger';
            icon = '⚠️';
            break;
        case 'medium':
            badgeColor = 'warning';
            icon = '⚠️';
            break;
        case 'low':
            badgeColor = 'info';
            icon = '📝';
            break;
        default:
            break;
    }

    return (
        <Badge bg={badgeColor} className="risk-badge">
            {icon} {risk.toUpperCase()} RISK
        </Badge>
    );
};

const IngredientCard = ({ ingredient }) => {
    return (
        <Card className="ingredient-card mb-3">
            <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                    <h5 className="ingredient-name">{ingredient.name}</h5>
                    <RiskBadge risk={ingredient.risk} />
                </div>

                <div className="ingredient-details mt-3">
                    <div className="detail-section">
                        <div className="detail-icon">💥</div>
                        <div className="detail-content">
                            <h6 className="detail-title">Potential Impact</h6>
                            <p className="detail-text">{ingredient.impact}</p>
                        </div>
                    </div>

                    <div className="detail-section">
                        <div className="detail-icon">❓</div>
                        <div className="detail-content">
                            <h6 className="detail-title">Why You Should Avoid It</h6>
                            <p className="detail-text fst-italic">{ingredient.whyAvoid}</p>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

const SafeIngredientsBadges = ({ ingredients }) => {
    return (
        <div className="safe-ingredients mt-4">
            <h5 className="safe-ingredients-title">
                <span className="safe-icon">✅</span> Safe Ingredients
            </h5>
            <div className="safe-badges-container">
                {ingredients.map((ingredient, idx) => (
                    <Badge key={idx} bg="success" className="safe-badge">
                        {ingredient}
                    </Badge>
                ))}
            </div>
        </div>
    );
};

const IngredientsList = ({ ingredients }) => {
    const hasConcerningIngredients = ingredients?.concerning?.length > 0;
    const hasSafeIngredients = ingredients?.safe?.length > 0;

    return (
        <Card className="ingredients-card shadow">
            <Card.Header className="ingredients-header">
                <h3 className="mb-0">
                    <span className="ingredients-icon">🧪</span> Ingredients Analysis
                </h3>
            </Card.Header>

            <Card.Body>
                {hasConcerningIngredients ? (
                    <div className="concerning-ingredients">
                        <h4 className="section-title">
                            <span className="warning-icon">⚠️</span> Concerning Ingredients
                        </h4>
                        <p className="text-muted mb-4">The following ingredients may have negative health impacts</p>

                        <Accordion defaultActiveKey="0" className="ingredients-accordion">
                            {ingredients.concerning.map((ingredient, idx) => (
                                <Accordion.Item key={idx} eventKey={idx.toString()} className="ingredient-accordion-item">
                                    <Accordion.Header>
                                        <span className="ingredient-name">{ingredient.name}</span>
                                        <RiskBadge risk={ingredient.risk} />
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col md={6}>
                                                <div className="detail-section">
                                                    <div className="detail-icon">💥</div>
                                                    <div className="detail-content">
                                                        <h6 className="detail-title">Potential Impact</h6>
                                                        <p className="detail-text">{ingredient.impact}</p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="detail-section">
                                                    <div className="detail-icon">❓</div>
                                                    <div className="detail-content">
                                                        <h6 className="detail-title">Why Avoid It</h6>
                                                        <p className="detail-text fst-italic">{ingredient.whyAvoid}</p>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                ) : (
                    <div className="no-concerning text-center p-4">
                        <div className="safe-checkmark">✅</div>
                        <h5 className="mt-3">No Concerning Ingredients Found</h5>
                        <p className="text-muted">This product appears to be free from harmful ingredients</p>
                    </div>
                )}

                {hasSafeIngredients && (
                    <div className="safe-ingredients-section mt-4">
                        <h4 className="section-title">
                            <span className="checkmark-icon">✅</span> Safe Ingredients
                        </h4>
                        <div className="safe-badges-container">
                            {ingredients.safe.map((ingredient, idx) => (
                                <Badge key={idx} bg="success" className="safe-badge">
                                    {ingredient}
                                </Badge>
                            ))}
                        </div>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default IngredientsList;
